import React, { useState } from "react";

const RenderTree = ({ categoryGroupList, onSelect, onClick }) => {
	const [list, setList] = useState(categoryGroupList);
	const level = 1;
	let timeout = null;

	const onSelectItem = (item, level) => {
		clearTimeout(timeout);
		item["loading"] = true;
		timeout = setTimeout(() => {
			const newList = deepItemUpdate(list, item, null, true);
			setList(newList);
		}, 5000);
		onSelect(item, level);
	};

	const closeItem = (item) => {
		const newList = deepItemUpdate(list, item, ["sub_category", "food_category"]);
		setList(newList);
	};

	const deepItemUpdate = (list, item, identifiers, loadingOnly = false) => {
		return list.filter((listItem) => {
			if (listItem === item) {
				!loadingOnly &&
					identifiers.map((identifier) => {
						return (item[identifier] = []);
					});
				item["loading"] = false;
				return item;
			}
			return deepItemUpdate(listItem["sub_category"], item, identifiers, loadingOnly);
		});
	};

	const renderItem = (item, index, level, hasLink, hasChild) => (
		<li className="tree-item" key={index}>
			<div
				className={`d-flex pointer align-items-center ${onSelect && hasLink ? "tree-item-link" : "tree-item-no-link"} ${
					hasChild ? "active" : ""
					} ${item.loading && !hasChild ? "loading" : ""} ${!hasLink ? "disabled" : ""}`}
				onClick={() =>
					onSelect && hasLink && !hasChild
						? onSelectItem(item, level + 1)
						: hasChild
							? closeItem(item)
							: onClick(item, level)
				}>
				<div className="flex-fill">{item.name ? item.name : item.long_desc ? item.long_desc : <i>-- No name</i>}</div>
				{item.count ? <div className="pl-3">{item.count}</div> : null}
			</div>
		</li>
	);

	const renderTreeLevel = (list, level, isFoodCategory = false, isRootList = false) => {
		return (
			<ul className={`tree-level ${isRootList ? "root-list" : ""}`}>
				{list && list.length ? (
					<React.Fragment>
						<li className="tree-head">{isFoodCategory ? "Food" : ""} Category</li>
						{list.map((item) => {
							const hasChild =
								(item.sub_category && item.sub_category.length) ||
								(item.food_category && item.food_category.length);
							return (
								<React.Fragment key={item.id}>
									{renderItem(item, item.id, level, item.hasLink, hasChild)}
									{item.sub_category && item.sub_category.length
										? renderTreeLevel(item.sub_category, level + 1)
										: null}
									{item.food_category && item.food_category.length
										? renderTreeLevel(item.food_category, level + 1, true)
										: null}
								</React.Fragment>
							);
						})}
					</React.Fragment>
				) : (
						<li className="tree-blank">No Items found!</li>
					)}
			</ul>
		);
	};

	return renderTreeLevel(list, level, false, true);
};

export default RenderTree;
